var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('seleccionar-fecha'),_c('nav-component'),_c('general'),_c('graficos'),_c('articulos'),_c('cheques')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }